// 登录页路由
import Layout from '@/view/qwAuth/layout' // qwLayout

export default {
  path: '/qwAuth',
  component: Layout,
  name: '企微layout',
  children: [
    {
      path: '/qwAuth/login',
      component: () => import(/* webpackChunkName: "auth-login" */ '@/view/qwAuth/index'),
      meta: {
        auth: false
      },
      name: '企业微信授权-登录'
    },
    {
      path: '/qwAuth/bindCS',
      component: () => import('@/view/qwAuth/bindCS'),
      name: 'index4'
    },
    {
      path: '/qwAuth/register',
      component: () => import('@/view/qwAuth/register'),
      name: 'register'
    },
    {
      path: '/qwAuth/bindPhone',
      component: () => import('@/view/qwAuth/bindPhone'),
      name: '绑定电话'
    },
    {
      path: '/qwAuth/createdApp',
      component: () => import('@/view/qwAuth/createdApp'),
      name: '添加应用'
    },
    {
      path: '/qwAuth/createdContacts',
      component: () => import('@/view/qwAuth/createdContacts'),
      name: '授权客户联系'
    },
    {
      path: '/qwAuth/configApp',
      component: () => import('@/view/qwAuth/configApp'),
      name: '添加客服'
    },
    {
      path: '/qwAuth/subConfig',
      component: () => import('@/view/qwAuth/subConfig'),
      name: '提交配置'
    }
  ]
}
